import Base from 'netxcore@netx/core-app/views/appBodyView';
import '../css/appBodyViews.less';

export default Base;
